import React, {Suspense} from 'react';
import {Route, Routes} from 'react-router-dom';
import ErrorPage404 from '@error/ErrorPage404';
import {retryLazy} from '@util/LazyUtil';
import Dashboard from '@page/Dashboard';
import DashboardDetail from '@page/DashboardDetail';
import SensorStatistics from '@page/SensorStatistics';
import SensorData from '@page/SensorData';


function Container({onChange}:{onChange:(flag:boolean)=> void}) {
    const getRoute = (routeList:React.ReactNode[]) => {
        const Template =  retryLazy(() => import('@page/Template'));

        // 퍼블용(완료 후 삭제 필요)
        const GuideComp         = retryLazy(() => import('@page/Guide'));

        // 가이드
        routeList.push( <Route key={'Guide'} path={'/Guide'} element={<GuideComp/>}/> );
        routeList.push(<Route key={'template'} path={'/template'} element={ <Template/>}/> );

        const Stats =  retryLazy(() => import('@page/Stats'));
        const Report =  retryLazy(() => import('@page/Report'));
        const Settings =  retryLazy(() => import('@page/Settings'));
        routeList.push( <Route key={'stats'} path={'/stats'} element={<Stats/>}/> );
        routeList.push( <Route key={'report'} path={'/report'} element={<Report/>}/> );
        routeList.push( <Route key={'settings'} path={'/settings'} element={<Settings/>}/> );
        routeList.push( <Route key={'dashboardDetail'} path={'/dashboard-detail'} element={<DashboardDetail/>}/> );
        routeList.push( <Route key={'sensorStatistics'} path={'/sensor-statistics'} element={<SensorStatistics/>}/> );
        routeList.push( <Route key={'sensorDetail'} path={'sensor-data'} element={<SensorData/>}/>);

        return routeList;
    };

    const createDashboard = () => {
        return <div>Dashboard 입니다!!!!</div>;
    };

    return (
        <div className={'container_wrap'}>
            <div className={'container_inner'}>
                <Suspense fallback={<></>}>
                    <Routes>
                        <Route key={'dashBoard'} path={'/'} element={<Dashboard onChange={onChange}/>}/>
                        {getRoute([])}
                        <Route key={'404-ErrorPage'} path={'*'}   element={<ErrorPage404 onChange={onChange}/>}/>
                    </Routes>
                </Suspense>
            </div>
        </div>
    );
}

export default Container;